// src/services/apiService.js
import axios from 'axios';

const API_URL = 'https://fauconbleu.ma/api/pwa';

const apiService = {
  // Car options
  async getCarOptions() {
    try {
      const response = await axios.get(`${API_URL}/brands`);
      return response.data;
    } catch (error) {
      console.error('Error fetching car options:', error);
      throw error;
    }
  },
  async getModelsByBrand(brandId : any) {
    try {
      const response = await axios.get(`${API_URL}/brands/${brandId}/models`);
      return response.data;
    } catch (error) {
      console.error('Error fetching models:', error);
      throw error;
    }
  },
  // Time slots
  async getTimeSlots(date : any) {
    try {
      const response = await axios.get(`${API_URL}/time-slots`, {
        params: { date }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching time slots:', error);
      throw error;
    }
  },

  // Locations
  async getLocations() {
    try {
      const response = await axios.get(`${API_URL}/locations`);
      return response.data;
    } catch (error) {
      console.error('Error fetching locations:', error);
      throw error;
    }
  },

  // Pricing
  async getPricing(data : any) {
    try {
      const response = await axios.post(`${API_URL}/pricing`, data);
      return response.data;
    } catch (error) {
      console.error('Error fetching pricing:', error);
      throw error;
    }
  },

  // Create reservation
  async createReservation(reservationData : any) {
    try {
      const response = await axios.post(`${API_URL}/reservations`, reservationData);
      return response.data;
    } catch (error) {
      console.error('Error creating reservation:', error);
      throw error;
    }
  },

  // Get reservation details
  async getReservation(orderNumber : any) {
    try {
      const response = await axios.get(`${API_URL}/reservations/${orderNumber}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reservation:', error);
      throw error;
    }
  },

  // Cancel reservation
  async cancelReservation(orderNumber : any) {
    try {
      const response = await axios.post(`${API_URL}/reservations/${orderNumber}/cancel`);
      return response.data;
    } catch (error) {
      console.error('Error canceling reservation:', error);
      throw error;
    }
  }
};

export default apiService;